import { useEffect } from "react";
import { Theme } from "../modules/profile/types/profile";
import { useThemeFetcher } from "../modules/profile/hooks/useThemeFetcher";
import { useThemeUpdater } from "../modules/profile/hooks/useThemeUpdater";
import { useUser } from "../../business-types/grocery/components/UserContext";

interface UseThemeReturn {
  theme: Theme | null;
  loading: boolean;
  storedColor: Theme[];
  backColor: string;
  fontColour: string;
  fontFamily: string;
  businessType: string;
  updateTheme: (newTheme: Theme) => Promise<{ success: boolean; error?: unknown }>;
}

export const useTheme = (): UseThemeReturn => {
  const { theme, loading, storedColor, setTheme, setStoredColor, fetchTheme } = useThemeFetcher();
  const { updateTheme } = useThemeUpdater(setTheme, setStoredColor);
  const { user } = useUser();
  const businessType = user?.business_type || "";

  useEffect(() => {
    fetchTheme();
    document.title = "Profile › iMetanic";
  }, [fetchTheme]);

  return {
    theme,
    loading,
    storedColor,
    backColor: theme?.background_color ?? "",
    fontColour: theme?.font_color ?? "",
    fontFamily: theme?.font_family ?? "",
    businessType,
    updateTheme,
  };
};

export default useTheme;